import { ArrowRight, Instagram, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../auth/AuthProvider";
import "./workspace.css";

export const WorkspacePage = () => {
  const navigate = useNavigate();
  const { viewer, signOut } = useAuth();

  if (!viewer) {
    return null;
  }

  const logout = async () => {
    await signOut();
    navigate("/auth/login", { replace: true });
  };

  return (
    <main className="workspace">
      <header className="workspace__header">
        <a className="brand-mark" href="/">
          reelio<span>.</span>
        </a>
        <div className="workspace__account">
          <span>{viewer.user.email}</span>
          <button type="button" onClick={logout}>
            <LogOut size={16} aria-hidden="true" />
            Sign out
          </button>
        </div>
      </header>

      <section className="workspace__content">
        <div className="workspace__intro">
          <p className="workspace__handle">
            <Instagram size={16} aria-hidden="true" />@
            {viewer.workspace.instagramHandle}
          </p>
          <h1>Welcome, {viewer.workspace.name}.</h1>
          <p>
            Your Reelio foundation is ready. Start by connecting your Shopify
            catalog and defining the content pillars for your first month.
          </p>
        </div>

        <section className="workspace__next">
          <div>
            <span>First setup step</span>
            <h2>Connect your Shopify store</h2>
            <p>
              Reelio will use your catalog, product details and reviews to
              create a clear monthly Instagram content plan.
            </p>
          </div>
          <button type="button" disabled>
            Coming next
            <ArrowRight size={18} aria-hidden="true" />
          </button>
        </section>
      </section>
    </main>
  );
};
